function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "logo");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD",
  transform: "translate(-33.000000, -19.000000)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "logo",
  transform: "translate(17.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(15.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("text", {
  id: "AllCats",
  fontFamily: "HanziPenSC-W5, HanziPen SC",
  fontSize: 36,
  fontWeight: "bold"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 38
}, "AllCats")), /*#__PURE__*/React.createElement("text", {
  id: "\\uD83D\\uDC08",
  fontFamily: "AppleColorEmoji, Apple Color Emoji",
  fontSize: 16,
  fontWeight: "normal"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 117,
  y: 36
}, "\uD83D\uDC08"))))));

var SvgAllcatsLogo = function SvgAllcatsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "136px",
    height: "30px",
    viewBox: "0 0 136 30",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAllcatsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Allcats_logo.36b8644a.svg";
export { ForwardRef as ReactComponent };